import actionCreatorFactory from "typescript-fsa";
import api from "../api";
import { Entity } from "../documentUpload/types";
import { State } from "../state";

import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";

const create = actionCreatorFactory("Entities");
const createAsync = asyncFactory<State>(create);

export const editEntity = createAsync<Entity, Entity>(
  "EDIT_ENTITY",
  async (entity, dispatch, getState) => {
    return await api.entities.edit(entity);
  }
);

const editEntityAction = thunkToAction(editEntity.action);
export type EditEntityActionType = typeof editEntityAction;

export const getEntity = createAsync<string, Entity>(
  "GET_ENTITY",
  async (entityId, dispatch, getState) => {
    return await api.entities.getOne(entityId);
  }
);

export const resetEntity = create("RESET_ENTITY");

const getEntityAction = thunkToAction(getEntity.action);
export type GetEntityActionType = typeof getEntityAction;



// WEBPACK FOOTER //
// ./src/entityView/actions.ts